'use client'

import { useId } from 'react'

interface KiteLogoProps {
  className?: string
}

export const KiteLogo = ({ className }: KiteLogoProps) => {
  // Generate unique IDs for this component instance to prevent Safari gradient conflicts
  const id = useId()
  const gradientA = `${id}-gradient-a`
  const gradientB = `${id}-gradient-b`
  const gradientC = `${id}-gradient-c`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59 18"
      fill="none"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <rect width="17.723" height="17.689" fill="#1A7CEC" rx="4.248" />
      <path
        fill={`url(#${gradientA})`}
        d="M8.223 12.756c.318 0 .577.258.577.576v1.193a.577.577 0 0 1-.578.577h-1.11a.577.577 0 0 1-.577-.577v-1.193c0-.318.259-.576.578-.576h1.11Z"
      />
      <path
        fill={`url(#${gradientB})`}
        d="M11.35 9.641c.319 0 .578.258.578.576v4.308a.577.577 0 0 1-.578.577h-1.11a.577.577 0 0 1-.577-.577v-4.308c0-.318.258-.576.577-.576h1.11Z"
      />
      <path
        fill={`url(#${gradientC})`}
        d="M14.477 6.516c.319 0 .577.258.577.576v7.433a.577.577 0 0 1-.577.577h-1.11a.577.577 0 0 1-.578-.577V7.092c0-.318.259-.576.578-.576h1.11Z"
      />
      <path
        fill="#fff"
        d="M13.304 2.587c.946 0 1.725.717 1.823 1.636v.538a.95.95 0 0 1-.952.95H12.95a.95.95 0 0 0-.952.95v1.223a.95.95 0 0 1-.951.95H9.817a.95.95 0 0 0-.951.95v1.223a.95.95 0 0 1-.952.95H6.686a.95.95 0 0 0-.951.95v1.244a.95.95 0 0 1-.952.95h-.35a1.832 1.832 0 0 1-1.833-1.83V4.418c0-1.01.82-1.83 1.833-1.83h8.87Z"
      />
      <path
        fill="#1C1C1E"
        fillRule="evenodd"
        d="M53.019 5.615c1.235 0 2.299.258 3.19.773a5.09 5.09 0 0 1 2.064 2.154c.485.92.727 2.021.727 3.3v.46a.457.457 0 0 1-.456.456l-7.54.035c-.278.001-.494.25-.42.518.11.398.272.728.488.99.454.515 1.15.773 2.087.773.689 0 1.26-.117 1.713-.351.334-.173.579-.396.735-.67.1-.176.272-.314.475-.314h2.43c.281 0 .498.252.426.523-.28 1.055-.885 1.919-1.814 2.591C56.044 17.618 54.7 18 53.089 18c-1.173 0-2.22-.265-3.143-.796a5.89 5.89 0 0 1-2.158-2.177c-.516-.936-.774-2.006-.774-3.207 0-1.218.25-2.287.75-3.208a5.669 5.669 0 0 1 2.135-2.2c.907-.531 1.947-.796 3.12-.796Zm.023 2.927c-.61 0-1.11.117-1.5.351-.376.234-.658.601-.845 1.1a2.064 2.064 0 0 0-.018.048c-.1.271.12.538.41.538h3.865c.252 0 .464-.207.416-.455a1.736 1.736 0 0 0-.592-1.02c-.422-.375-1-.562-1.736-.562Z"
        clipRule="evenodd"
      />
      <path
        fill="#1C1C1E"
        d="M24.908 9.014c0 .418.518.616.798.305l2.866-3.178a.458.458 0 0 1 .34-.15h3.257c.402 0 .61.48.332.77l-3.436 3.612a.456.456 0 0 0-.06.55l3.671 6.08a.457.457 0 0 1-.392.693h-3.105a.458.458 0 0 1-.393-.222l-2.185-3.64a.458.458 0 0 0-.724-.08l-.843.883a.456.456 0 0 0-.126.315v2.287a.457.457 0 0 1-.458.457h-2.696a.457.457 0 0 1-.458-.457V.5c0-.253.205-.457.458-.457h2.696c.253 0 .458.204.458.457v8.513ZM37.4 17.239a.457.457 0 0 1-.457.457h-2.697a.457.457 0 0 1-.458-.457V6.447c0-.252.205-.457.458-.457h2.697c.253 0 .457.205.457.457v10.792ZM44.38 5.533c0 .253.204.457.457.457h1.313c.253 0 .458.205.458.457V8.53a.457.457 0 0 1-.458.457h-1.313a.457.457 0 0 0-.458.457v7.795a.457.457 0 0 1-.457.457h-2.697a.457.457 0 0 1-.458-.457V9.444a.457.457 0 0 0-.458-.457h-1.313a.457.457 0 0 1-.457-.457V6.447c0-.252.205-.457.457-.457h1.313a.457.457 0 0 0 .458-.457V2.818c0-.252.205-.457.458-.457h2.697c.252 0 .457.205.457.457v2.715ZM35.571.416c.563 0 1.04.195 1.43.585.407.39.61.874.61 1.452 0 .577-.203 1.069-.61 1.474-.39.39-.867.586-1.43.586a2.057 2.057 0 0 1-1.478-.586 2.048 2.048 0 0 1-.586-1.474c0-.578.195-1.062.586-1.452.407-.39.9-.585 1.478-.585Z"
      />
      <defs>
        <linearGradient
          id={gradientA}
          x1="11.651"
          x2="9.673"
          y1="15.102"
          y2="10.028"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FF5" />
          <stop offset="1" stopColor="#6FA2FF" />
        </linearGradient>
        <linearGradient
          id={gradientB}
          x1="11.651"
          x2="9.673"
          y1="15.102"
          y2="10.028"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FF5" />
          <stop offset="1" stopColor="#6FA2FF" />
        </linearGradient>
        <linearGradient
          id={gradientC}
          x1="11.651"
          x2="9.673"
          y1="15.102"
          y2="10.028"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FF5" />
          <stop offset="1" stopColor="#6FA2FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
